// extracted by css-extract-rspack-plugin
export default {"apexcharts-title-label":"apexcharts-title-label-Ha68Xx","apexchartsTitleLabel":"apexcharts-title-label-Ha68Xx"};